(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tbc-core-beers"]) return;
  try {
    
document.querySelectorAll('[data-core-list]').forEach(function(list){Array.from(list.children).sort(function(a,b){return Number(a.dataset.coreOrder)-Number(b.dataset.coreOrder)}).forEach(function(item){list.appendChild(item)})});
document.querySelectorAll('.tbc-core').forEach(function(root){function activate(tab){root.querySelectorAll('[data-core-tab]').forEach(function(item){item.setAttribute('aria-selected',item===tab?'true':'false')});root.querySelectorAll('.tbc-core__panel').forEach(function(panel){panel.hidden=panel.id!=='tbc-'+tab.dataset.coreTab})}root.querySelectorAll('[data-core-tab]').forEach(function(tab){tab.addEventListener('click',function(){activate(tab);history.replaceState(null,'','#'+tab.dataset.coreTab)})});var initial=root.querySelector('[data-core-tab="'+location.hash.slice(1)+'"]');if(initial)activate(initial)});
if(window.IntersectionObserver&&window.matchMedia('(hover: none), (pointer: coarse)').matches){const observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){entry.target.classList.toggle('is-in-view',entry.isIntersecting&&entry.intersectionRatio>=.6)})},{threshold:[0,.6,1]});document.querySelectorAll('[data-core-secondary]').forEach(function(item){observer.observe(item)})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbc-editorial-awards"]) return;
  try {
    
document.querySelectorAll('[data-awards-filter]').forEach(function(root){
  if(root.dataset.awardsReady)return;
  root.dataset.awardsReady='true';
  var medal=root.querySelector('[data-awards-medal]');
  var beer=root.querySelector('[data-awards-beer]');
  var reset=root.querySelector('[data-awards-reset]');
  var count=root.querySelector('[data-awards-count]');
  var empty=root.querySelector('[data-awards-empty]');
  function update(){
    var visible=0;
    root.querySelectorAll('.tbc-awards__year').forEach(function(year){
      var yearVisible=0;
      year.querySelectorAll('[data-awards-card]').forEach(function(card){
        var match=(!medal.value||card.dataset.medal===medal.value)&&(!beer.value||card.dataset.beer===beer.value);
        card.hidden=!match;
        if(match){visible++;yearVisible++}
      });
      year.hidden=yearVisible===0;
    });
    count.textContent=visible+' '+(visible===1?'award':'awards');
    empty.hidden=visible!==0;
    reset.hidden=!medal.value&&!beer.value;
  }
  medal.addEventListener('change',update);
  beer.addEventListener('change',update);
  reset.addEventListener('click',function(){medal.value='';beer.value='';update()});
  update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbc-editorial-story"]) return;
  try {
    
document.querySelectorAll('.tbc-story__chapters').forEach(function (container) { Array.from(container.children).sort(function (a,b) { return Number(a.dataset.editorialOrder)-Number(b.dataset.editorialOrder); }).forEach(function (item) { container.appendChild(item); }); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbc-editorial-team"]) return;
  try {
    
document.querySelectorAll('.tbc-team__grid').forEach(function (container) { Array.from(container.children).sort(function (a,b) { return Number(a.dataset.editorialOrder)-Number(b.dataset.editorialOrder); }).forEach(function (item) { container.appendChild(item); }); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbc-keg-rental"]) return;
  try {
    
(function(){
  var root=document.getElementById('KegRental'); if(!root)return;
  var form=document.getElementById('KegRentalForm'),inputs=[].slice.call(root.querySelectorAll('[data-keg-item]'));
  var vat=Number(root.dataset.vat)||0,deposit=Number(root.dataset.deposit)||0,delivery=Number(root.dataset.delivery)||0,lead=Number(root.dataset.leadDays)||3;
  var deliveryFields=document.getElementById('KegDeliveryFields'),pickupFields=document.getElementById('KegPickupFields');
  var pickup=document.getElementById('KegPickupLocation'),address=document.getElementById('KegDeliveryAddress'),date=document.getElementById('KegRentalDate');
  function money(n){return 'TTD$'+n.toLocaleString('en-TT',{minimumFractionDigits:2,maximumFractionDigits:2})}
  function selectedDelivery(){var field=form.querySelector('input[name="contact[Fulfilment]"]:checked');return field&&field.value==='Delivery'}
  function update(){
    var lines=[],subtotal=0,count=0;
    inputs.forEach(function(input){if(input.disabled)return;var qty=Math.max(0,Math.min(50,parseInt(input.value,10)||0));if(qty){var price=Number(input.dataset.price)||0;subtotal+=qty*price;count+=qty;lines.push({label:qty+' × '+input.dataset.itemName+(input.dataset.size==='Rental'?'':' '+input.dataset.size),amount:qty*price})}});
    var deliveryAmount=selectedDelivery()?delivery:0,vatAmount=subtotal*vat/100,depositAmount=count*deposit;
    var list=document.getElementById('KegRentalLines');list.textContent='';if(!lines.length){list.textContent='Select at least one keg to see your estimate.'}else{lines.forEach(function(line){var div=document.createElement('div'),name=document.createElement('span'),amount=document.createElement('span');name.textContent=line.label;amount.textContent=money(line.amount);div.appendChild(name);div.appendChild(amount);list.appendChild(div)})}
    document.getElementById('KegSubtotal').textContent=money(subtotal);document.getElementById('KegDelivery').textContent=money(deliveryAmount);document.getElementById('KegVat').textContent=money(vatAmount);document.getElementById('KegDeposit').textContent=money(depositAmount);document.getElementById('KegTotal').textContent=money(subtotal+deliveryAmount+vatAmount+depositAmount);
    deliveryFields.hidden=!selectedDelivery();pickupFields.hidden=!!selectedDelivery();pickup.required=!selectedDelivery();address.required=!!selectedDelivery();
    return {lines:lines,subtotal:subtotal,delivery:deliveryAmount,vat:vatAmount,deposit:depositAmount,total:subtotal+deliveryAmount+vatAmount+depositAmount,kegs:inputs.filter(function(i){return !i.disabled&&i.dataset.size!=='Rental'}).reduce(function(n,i){return n+(parseInt(i.value,10)||0)},0)}
  }
  var earliest=new Date();earliest.setHours(12,0,0,0);var days=0;while(days<lead){earliest.setDate(earliest.getDate()+1);if(earliest.getDay()!==0&&earliest.getDay()!==6)days++}date.min=earliest.getFullYear()+'-'+String(earliest.getMonth()+1).padStart(2,'0')+'-'+String(earliest.getDate()).padStart(2,'0');
  root.querySelectorAll('[data-keg-choice]').forEach(function(choice){var toggle=choice.querySelector('[data-keg-toggle]'),options=choice.querySelector('[data-keg-options]'),fields=choice.querySelectorAll('[data-keg-item]');toggle.addEventListener('change',function(){options.hidden=!toggle.checked;fields.forEach(function(field){field.disabled=!toggle.checked;if(!toggle.checked)field.value='0'});update()})});
  inputs.forEach(function(input){input.addEventListener('input',update)});form.querySelectorAll('input[name="contact[Fulfilment]"]').forEach(function(input){input.addEventListener('change',update)});
  form.addEventListener('submit',function(event){var state=update();if(!state.kegs){event.preventDefault();alert('Please choose at least one keg before sending your request.');return}if(date.value<date.min){event.preventDefault();date.setCustomValidity('Please choose a date at least '+lead+' working days from today.');date.reportValidity();return}date.setCustomValidity('');var body=['KEG RENTAL ENQUIRY','', 'Items:'];state.lines.forEach(function(line){body.push('- '+line.label+' — '+money(line.amount))});body.push('', 'Date required: '+date.value,'Fulfilment: '+(selectedDelivery()?'Delivery':'Pick up'),'Location/address: '+(selectedDelivery()?address.value:pickup.options[pickup.selectedIndex].text),'Phone: '+form.querySelector('[name="contact[phone]"]').value,'Notes: '+document.getElementById('KegRentalNotes').value,'','Estimated items: '+money(state.subtotal),'Delivery: '+money(state.delivery),'VAT: '+money(state.vat),'Refundable deposits: '+money(state.deposit),'Estimated total: '+money(state.total),'','Subject to availability. This enquiry is not a confirmed order.');document.getElementById('KegRentalBody').value=body.join('\n')});
  date.addEventListener('input',function(){date.setCustomValidity('')});update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbc-menu-page"]) return;
  try {
    
document.querySelectorAll('[data-tbc-menu]').forEach(function (menu) {
  menu.querySelectorAll('.tbc-menu__items').forEach(function (group) {
    var items = Array.from(group.children);
    var unplaced = items.filter(function (item) { return !item.dataset.menuOrder; });
    unplaced.sort(function (a, b) { return Number(a.dataset.menuId) - Number(b.dataset.menuId); });
    var placed = items.filter(function (item) { return item.dataset.menuOrder; });
    placed.sort(function (a, b) {
      return Number(a.dataset.menuOrder) - Number(b.dataset.menuOrder);
    });
    placed.forEach(function (item) {
      var position = Math.max(1, Math.floor(Number(item.dataset.menuOrder) || 1));
      unplaced.splice(Math.min(position - 1, unplaced.length), 0, item);
    });
    unplaced.forEach(function (item, index) {
      item.dataset.effectiveMenuOrder = String(index + 1);
      group.appendChild(item);
    });
  });
  var tabs = Array.from(menu.querySelectorAll('[data-menu-tab]'));
  var panels = Array.from(menu.querySelectorAll('[data-menu-panel]'));
  var tapTabs = Array.from(menu.querySelectorAll('[data-tap-tab]'));
  var tapPanels = Array.from(menu.querySelectorAll('[data-tap-panel]'));
  function showTaproom(key, updateHash) {
    tapTabs.forEach(function (tab) {
      var selected = tab.dataset.tapTab === key;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });
    tapPanels.forEach(function (panel) { panel.hidden = panel.dataset.tapPanel !== key; });
    menu.querySelectorAll('[data-drink-locations]').forEach(function (item) {
      item.hidden = item.dataset.drinkLocations.split(' ').indexOf(key) === -1;
    });
    if (updateHash) history.replaceState(null, '', '#menu-drinks-' + key);
  }
  function show(key, updateHash) {
    tabs.forEach(function (tab) {
      var selected = tab.dataset.menuTab === key;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });
    panels.forEach(function (panel) { panel.hidden = panel.dataset.menuPanel !== key; });
    if (updateHash) history.replaceState(null, '', '#menu-' + key);
    if (updateHash) {
      var activePanel = panels.find(function (panel) { return panel.dataset.menuPanel === key; });
      if (activePanel) activePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  tabs.forEach(function (tab, index) {
    tab.addEventListener('click', function () { show(tab.dataset.menuTab, true); });
    tab.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      var next = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      tabs[next].focus();
      show(tabs[next].dataset.menuTab, true);
    });
  });
  tapTabs.forEach(function (tab, index) {
    tab.addEventListener('click', function () { showTaproom(tab.dataset.tapTab, true); });
    tab.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      var next = (index + (event.key === 'ArrowRight' ? 1 : -1) + tapTabs.length) % tapTabs.length;
      tapTabs[next].focus();
      showTaproom(tapTabs[next].dataset.tapTab, true);
    });
  });
  menu.querySelectorAll('[data-menu-category-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var target = document.getElementById(select.value);
      if (!target) return;
      history.replaceState(null, '', '#' + select.value);
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
  var hash = decodeURIComponent(location.hash);
  var match = tabs.find(function (tab) { return hash === '#menu-' + tab.dataset.menuTab || hash.indexOf('#menu-' + tab.dataset.menuTab + '-') === 0; });
  if (match) show(match.dataset.menuTab, false);
  var tapMatch = tapTabs.find(function (tab) { return hash === '#menu-drinks-' + tab.dataset.tapTab || hash.indexOf('#menu-drinks-' + tab.dataset.tapTab + '-') === 0; });
  showTaproom(tapMatch ? tapMatch.dataset.tapTab : 'movie-towne', false);
});

  } catch(e) { console.error(e); }
})();
})();
